import React from 'react';

const CheckNextIcon = ({className}) => (
  <svg className={className} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12.5" cy="12.5" r="12.5" fill="white"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M16.0078 8.1338L11.63 12.512L10.3543 11.2834L10.3307 11.2596C9.71654 10.6456 8.72384 10.6456 8.11029 11.2596C7.49613 11.8738 7.49613 12.8661 8.11029 13.4803L8.13386 13.5037L10.4959 15.8663C11.0969 16.4934 12.0786 16.5036 12.6931 15.8894L12.7164 15.8663L18.2282 10.3541L18.2398 10.3426C18.8607 9.72202 18.8552 8.72417 18.2282 8.1102L18.2166 8.09871C17.5957 7.49133 16.6088 7.50685 16.0078 8.1338Z" fill="#00D9CD"/>
  </svg>
);

export default CheckNextIcon;
